import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {DataFormatService} from "../../../../services/data-format.service";
import {formatCurrency} from "@angular/common";

export interface DInfoTable {
  field: string;
  value: string;
}

@Component({
    selector: 'deal-disposition-info-table',
    templateUrl: './disposition-info-table.component.html',
    styleUrls: ['./disposition-info-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DispositionInfoTableComponent implements OnInit{
  @Input() disposition: any;

  dInfoColumns: string[] = ['field', 'value'];
  dInfoDataSource: MatTableDataSource<DInfoTable>;

  constructor(private dataFormat: DataFormatService) {}

  ngOnInit() {
    let formatted: Array<DInfoTable> = [
      {field: "Total Distribution Amount", value: formatCurrency(this.disposition.total_distribution_amount, 'EN', '$', 'USD', '1.0-0')},
      {field: "Broker's Opinion of Value", value: this.dataFormat.yesNoFormat(this.disposition.bov)},
      {field: "General Partner", value: this.dataFormat.yesNoFormat(this.disposition.general_partner)}
    ];

    if(this.disposition.dispositionPreviousOwner){
      formatted.push({field: "Previous Owner", value: this.disposition.dispositionPreviousOwner.ownedEntity.name});
    }

    this.dInfoDataSource = new MatTableDataSource(formatted);
  }
}
